export const filterNavigationItems = (
  navItems,
  brandConfig,
  currentAccount = null,
) => {
  // If we have custom navigation items (like for test client), use those instead
  if (
    brandConfig.navigation.customNavItems &&
    brandConfig.navigation.customNavItems.length > 0
  ) {
    // Filter custom navigation items based on current account's business mode
    let filteredCustomItems = brandConfig.navigation.customNavItems;

    // Hide Products page for lead generation businesses
    // Use the current account's business mode, not the brand config's business mode
    if (currentAccount && currentAccount.businessMode === "leadgen") {
      filteredCustomItems = filteredCustomItems.filter(
        (item) => item.title !== "Products",
      );
    }

    // Return custom navigation items sorted by order
    return filteredCustomItems
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((item) => ({
        title: item.title,
        href: item.href,
        // Convert to the expected format
      }));
  }

  // Otherwise, use the standard filtering logic
  return navItems
    .filter((item) => {
      // Check if this item should be hidden
      const shouldHide = brandConfig.navigation.hideItems[item.title];
      return !shouldHide;
    })
    .map((item) => {
      // Filter sub-items if they exist
      if (item.items) {
        return {
          ...item,
          items: item.items.filter((subItem) => {
            const shouldHide = brandConfig.navigation.hideItems[subItem.title];
            return !shouldHide;
          }),
        };
      }
      return item;
    });
};

// Check if a feature is enabled
export const isFeatureEnabled = (brandConfig, featureName) => {
  return brandConfig.features && brandConfig.features[featureName] === true;
};

// Helper function to get brand-specific text/content
export const getBrandText = (path, brandConfig) => {
  if (!brandConfig) return null;

  const pathArray = path.split(".");
  let current = brandConfig;

  for (const key of pathArray) {
    if (current && current[key]) {
      current = current[key];
    } else {
      return null;
    }
  }

  return current;
};
